import React, { useEffect, useState } from 'react';
import { MapPin, CheckCircle2, Circle } from 'lucide-react';

export const ARRIVAL_RADIUS_M = 150;

export const distanceM = (a, b) => {
  const R = 6371000;
  const toRad = (x) => (x * Math.PI) / 180;
  const dLat = toRad(b[0] - a[0]);
  const dLon = toRad(b[1] - a[1]);
  const h = Math.sin(dLat / 2) ** 2 + Math.cos(toRad(a[0])) * Math.cos(toRad(b[0])) * Math.sin(dLon / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(h));
};

// Stop binnen straal met nog niet opgehaalde motoren, die nog niet is weggeklikt.
export const findArrivedStop = (stops, pos, dismissed) => {
  if (!pos) return null;
  return stops.find((s) => s.position && !dismissed.has(s.company)
    && s.motors.some((m) => !m.picked_up)
    && distanceM([pos.lat, pos.lon], s.position) <= ARRIVAL_RADIUS_M) || null;
};

export const ArrivalPrompt = ({ stop, onConfirm, onLater, busy }) => {
  const open = stop.motors.filter((m) => !m.picked_up);
  const [checked, setChecked] = useState(new Set(open.map((m) => m.order_id)));

  useEffect(() => { navigator.vibrate?.([200, 100, 200]); }, []);

  const flip = (id) => setChecked((c) => {
    const n = new Set(c);
    if (n.has(id)) n.delete(id); else n.add(id);
    return n;
  });

  return (
    <div className="fixed inset-0 z-50 bg-zinc-950/80 flex items-end sm:items-center justify-center p-3" data-testid="arrival-prompt">
      <div className="w-full max-w-md bg-white rounded-2xl overflow-hidden shadow-2xl">
        <div className="bg-emerald-600 text-white p-5">
          <div className="flex items-center gap-2 text-sm font-medium opacity-90"><MapPin className="w-4 h-4" /> Je bent aangekomen bij</div>
          <div className="text-2xl font-bold mt-1" data-testid="arrival-company">{stop.company}</div>
          <div className="text-sm mt-1 opacity-90">{open.length} motor(en) ingeladen?</div>
        </div>
        <div className="max-h-[45vh] overflow-auto">
          {open.map((m) => (
            <button key={m.order_id} onClick={() => flip(m.order_id)}
                    className="w-full flex items-center gap-3 px-5 py-3 border-b border-zinc-100 text-left"
                    data-testid={`arrival-motor-${m.order_id}`}>
              {checked.has(m.order_id)
                ? <CheckCircle2 className="w-7 h-7 text-emerald-600 shrink-0" />
                : <Circle className="w-7 h-7 text-zinc-300 shrink-0" />}
              <div className="min-w-0">
                <div className="font-semibold text-zinc-900">{`${m.make} ${m.model}`.trim() || 'Motor'}</div>
                <div className="text-xs text-zinc-500 font-mono truncate">{[m.license_plate, m.vin].filter(Boolean).join(' · ') || '—'}</div>
              </div>
            </button>
          ))}
        </div>
        <div className="p-4 grid grid-cols-[1fr_2fr] gap-2">
          <button onClick={onLater} className="py-4 rounded-xl bg-zinc-100 text-zinc-700 font-semibold" data-testid="arrival-later">Later</button>
          <button onClick={() => onConfirm([...checked])} disabled={busy || checked.size === 0}
                  className="py-4 rounded-xl bg-emerald-600 text-white font-bold text-lg disabled:opacity-40" data-testid="arrival-confirm">
            {busy ? 'Opslaan…' : checked.size === open.length ? 'Ja, alles ingeladen' : `Ja, ${checked.size} ingeladen`}
          </button>
        </div>
      </div>
    </div>
  );
};
